import React from 'react';

const emptyResults = () => (
  <h4 className="font-weight-bold">No reporters found matching this search.</h4>
);

export default emptyResults;
